import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import { filteredSubtasks } from '../../use';

const { registerReducer } = useStorymapStore();

export class MultiSelectCardsByFilters extends Action<StorymapState> {
    public static ACTION_TYPE = 'MultiSelectCardsByFilters';

    public constructor(public releaseId: string = null) {
        super(MultiSelectCardsByFilters.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: MultiSelectCardsByFilters): void => {
    filteredSubtasks.value
        .filter((x) => action.releaseId == null || x.releaseId == action.releaseId)
        .forEach((x) => (x.isMultiselected = true));
};

//@ts-ignore
registerReducer(MultiSelectCardsByFilters.ACTION_TYPE, reducer);
